export enum DeliveryNoteStatus {
  ALL = 'ALL',
  AVAILABLE_TO_BE_ISSUED = 'AVAILABLE_TO_BE_ISSUED',
  NOT_RECEIVED = 'NOT_RECEIVED',
  ISSUED = 'ISSUED'
}
